import { create } from 'zustand';
export const useUIStore = create()((set) => ({
    errorTitle: '',
    errorMessage: '',
    errorVisible: false,
    setError: (title, message) => {
        set(() => ({
            errorTitle: title,
            errorMessage: message,
            errorVisible: true,
        }));
    },
    hideError: () => set({ errorVisible: false }),
}));
